"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterSearchRequestSchema = exports.searchRequestSchema = exports.emptyBodySchema = exports.emailSchema = exports.stringBooleanSchema = exports.nonEmptyLooseObjectSchema = exports.looseObjectSchema = exports.metadataSchema = exports.tokenIdParamSchema = exports.idParamSchema = void 0;
const zod_1 = require("zod");
exports.idParamSchema = zod_1.z
    .object({
    id: zod_1.z.string().min(1),
})
    .strict();
exports.tokenIdParamSchema = zod_1.z
    .object({
    tokenId: zod_1.z.string().min(1),
})
    .strict();
exports.metadataSchema = zod_1.z.record(zod_1.z.string(), zod_1.z.unknown());
exports.looseObjectSchema = zod_1.z.record(zod_1.z.string(), zod_1.z.unknown());
exports.nonEmptyLooseObjectSchema = exports.looseObjectSchema.refine((value) => Object.keys(value).length > 0, "Expected at least one field");
exports.stringBooleanSchema = zod_1.z.union([zod_1.z.boolean(), zod_1.z.enum(["true", "false"])]);
exports.emailSchema = zod_1.z.string().trim().email();
exports.emptyBodySchema = zod_1.z.object({}).strict();
exports.searchRequestSchema = zod_1.z
    .object({
    query: zod_1.z.string().optional(),
    page: zod_1.z.coerce.number().int().positive().optional(),
    limit: zod_1.z.coerce.number().int().positive().max(100).optional(),
})
    .strict();
exports.filterSearchRequestSchema = zod_1.z
    .object({
    filters: exports.looseObjectSchema.default({}).optional(),
    pagination: exports.looseObjectSchema.default({}).optional(),
})
    .strict();
//# sourceMappingURL=base.js.map